import { render } from "./eski_index.vue?vue&type=template&id=61c0fbdc"
import script from "./eski_index.vue?vue&type=script&lang=js"
export * from "./eski_index.vue?vue&type=script&lang=js"

import "./eski_index.vue?vue&type=style&index=0&id=61c0fbdc&lang=css"

import exportComponent from "/var/www/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__